/* RESPONSIBLE TEAM: team-knowledge-foundations */

/**
 * Extracts the subdomain from a Zendesk URL
 * @param url - The Zendesk URL (e.g., "https://example.zendesk.com")
 * @returns The subdomain (e.g., "example")
 */
export function extractZendeskSubdomain(url: string): string {
  try {
    let parsedUrl = new URL(url);
    let hostname = parsedUrl.hostname;

    let match = hostname.match(/^([^.]+)\.zendesk\.com$/);
    if (match) {
      return match[1];
    }

    return hostname;
  } catch (e) {
    let match = url.match(/https?:\/\/([^.]+)\.zendesk\.com/);
    return match ? match[1] : url;
  }
}
